export const STATUS_REQUEST_TRAINING = {
    1: {
        label: "Nháp",
        class: "magenta"
    },
    2: {
        label: "Chờ HTKD duyệt",
        class: "orange"
    },
    3: {
        label: "HTKD từ chối",
        class: "red"
    },
    4: {
        label: "Chờ giám đốc duyệt",
        class: "orange"
    },
    5:{
        label: "Giám đốc từ chối",
        class: "red"
    },
    6:{
        label: "Hoàn thành",
        class: "green"
    },
    7:{
        label: "Đã xuất token",
        class: "geekblue"
    }
};